import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { LeaderboardIntroResourcePackage } from "../resources/LeaderboardIntroResourcePackage";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";

export class LeaderboardIntroDescriptionContainer extends Container {
    private static readonly PLAY_TEXT = "PLAY";
    private static readonly ROLL_DICE_TEXT = "ROLL DICE";
    private static readonly EARN_COINS_TEXt = "EARN COINS";
    private static readonly UPGRADE_BUILDING_TEXT = "UPGRADE\nBUILDING";
    private static readonly GAIN_TEXT = "GAIN";
    private static readonly OWN_POINTS_TEXT = "OWN POINTS";
    private static readonly MOVE_TO_TOP_TEXT = "MOVE TO TOP";
    private static readonly CONTEST_TEXT = "ON CONTEST LEADERBOARD";
    private static readonly EARN_TEXT = "EARN";

    public constructor(
        private readonly commonResources: CommonResourcesPackage,
        private readonly leaderboardIntroResources: LeaderboardIntroResourcePackage
    ) {
        super();
        this.buildTexts();
    }

    private buildTexts(): void {
        const crownIcon = new Sprite(this.leaderboardIntroResources.assets_views_leaderboard_intro_crown_png);
        const playText = new Text(LeaderboardIntroDescriptionContainer.PLAY_TEXT, new WhiteTextStyle());
        playText.position.set(crownIcon.x + crownIcon.width * 0.5 - playText.width * 0.5, crownIcon.y + crownIcon.height + 3);
        const arrow1 = new Sprite(this.leaderboardIntroResources.assets_views_leaderboard_intro_arrow_png);
        arrow1.scale.set(0.5);
        arrow1.position.set(playText.x + playText.width + 10, 95);

        const rollIcon = new Sprite(this.leaderboardIntroResources.assets_views_leaderboard_intro_dice_png);
        rollIcon.position.set(165, 46);
        const rollDiceText = new Text(LeaderboardIntroDescriptionContainer.ROLL_DICE_TEXT, new WhiteTextStyle());
        rollDiceText.position.set(rollIcon.x + rollIcon.width * 0.5 - rollDiceText.width * 0.5 + 3, rollIcon.y + rollIcon.height + 5);
        const arrow2 = new Sprite(this.leaderboardIntroResources.assets_views_leaderboard_intro_arrow_png);
        arrow2.scale.set(0.5);
        arrow2.position.set(rollDiceText.x + rollDiceText.width + 33, 150);

        const coinIcon = new Sprite(this.leaderboardIntroResources.assets_views_leaderboard_intro_coin_png);
        coinIcon.position.set(407, 83);
        const earnCoinsText = new Text(LeaderboardIntroDescriptionContainer.EARN_COINS_TEXt, new WhiteTextStyle());
        earnCoinsText.position.set(coinIcon.x + coinIcon.width * 0.5 - earnCoinsText.width * 0.5 + 2, coinIcon.y + coinIcon.height + 3);

        const buildingIcon = new Sprite(this.leaderboardIntroResources.assets_views_leaderboard_intro_building_icon_png);
        buildingIcon.position.set(74, 236);
        const upgradeBuildingTextText = new Text(LeaderboardIntroDescriptionContainer.UPGRADE_BUILDING_TEXT, new GreenTextStyle());
        upgradeBuildingTextText.position.set(buildingIcon.x + buildingIcon.width * 0.5 - upgradeBuildingTextText.width * 0.5, buildingIcon.y + buildingIcon.height + 8);
        const arrow3 = new Sprite(this.leaderboardIntroResources.assets_views_leaderboard_intro_arrow_png);
        arrow3.position.set(285, 358);

        const tokenIcon = new Sprite(this.commonResources.assets_common_ui_top_panel_token_icon_png);
        tokenIcon.position.set(464, 267);
        const gainText = new Text(LeaderboardIntroDescriptionContainer.GAIN_TEXT, new BlueTextStyle());
        gainText.position.set(tokenIcon.x + tokenIcon.width * 0.5 - gainText.width * 0.5, tokenIcon.y + tokenIcon.height + 6);
        const ownPointsText = new Text(LeaderboardIntroDescriptionContainer.OWN_POINTS_TEXT, new BlueTextStyle());
        ownPointsText.style.fontSize = 47;
        ownPointsText.position.set(gainText.x, gainText.y + gainText.height - 18);

        const trophyIcon = new Sprite(this.leaderboardIntroResources.assets_views_leaderboard_intro_trophy_png);
        trophyIcon.position.set(127, 444);
        const moveTopText = new Text(LeaderboardIntroDescriptionContainer.MOVE_TO_TOP_TEXT, new OrangeTextStyle());
        moveTopText.position.set(trophyIcon.x + trophyIcon.width * 0.5 - moveTopText.width * 0.5 - 11, trophyIcon.y + trophyIcon.height + 21);
        const contestText = new Text(LeaderboardIntroDescriptionContainer.CONTEST_TEXT, new WhiteTextStyle());
        contestText.style.fontSize = 42;
        contestText.position.set(moveTopText.x, moveTopText.y + moveTopText.height - 10);
        const arrow4 = new Sprite(this.leaderboardIntroResources.assets_views_leaderboard_intro_arrow_png);
        arrow4.scale.set(0.5);
        arrow4.position.set(348, 611);

        const earnText = new Text(LeaderboardIntroDescriptionContainer.EARN_TEXT, new WhiteTextStyle());
        earnText.style.fontSize = 93;
        earnText.position.set(408, 602);

        this.updateTextRotation([
            playText,
            rollDiceText,
            earnCoinsText,
            upgradeBuildingTextText,
            gainText,
            ownPointsText,
            moveTopText,
            contestText,
            earnText
        ]);

        this.addChild(
            crownIcon,
            playText,
            arrow1,
            rollIcon,
            rollDiceText,
            arrow2,
            coinIcon,
            earnCoinsText,
            buildingIcon,
            upgradeBuildingTextText,
            arrow3,
            tokenIcon,
            gainText,
            ownPointsText,
            trophyIcon,
            moveTopText,
            contestText,
            arrow4,
            earnText
        )
    }

    private updateTextRotation(texts: Array<Text>): void {
        for (const text of texts) {
            text.angle = -5;
            text.skew.x = -0.08;
        }
    }
}

class WhiteTextStyle extends TextStyle {
    public constructor() {
        super({
            align: "left",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 68
        });
    }
}

class GreenTextStyle extends TextStyle {
    public constructor() {
        super({
            align: "center",
            fill: [
                "#a9fd0a",
                "#19d014"
            ],
            fillGradientType: 0,
            fillGradientStops: [
                0,
                0.9
            ],
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 84,
            leading: -15
        });
    }
}

class OrangeTextStyle extends TextStyle {
    public constructor() {
        super({
            align: "center",
            fill: [
                "#ffe202",
                "#ffbb10"
            ],
            fillGradientType: 0,
            fillGradientStops: [
                0,
                0.9
            ],
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 87
        });
    }
}

class BlueTextStyle extends TextStyle {
    public constructor() {
        super({
            align: "center",
            fill: [
                "#00F7FF",
                "#3481FF"
            ],
            fillGradientType: 1,
            fillGradientStops: [
                0,
                0.9
            ],
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 122
        });
    }
}
